// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Delete: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M13.5 2.5h-2.574L9.863.727C9.566.276 9.106 0 8.581 0H5.42c-.525 0-1.013.276-1.281.727L3.074 2.5H.5c-.277 0-.5.223-.5.5v.5c0 .278.223.5.5.5H1v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4h.5c.278 0 .5-.222.5-.5V3c0-.277-.222-.5-.5-.5Zm-8.128-.91a.185.185 0 0 1 .16-.09h2.937c.066 0 .129.035.16.09l.546.91h-4.35l.547-.91ZM11 14.5H3a.5.5 0 0 1-.5-.5V4h9v10c0 .275-.225.5-.5.5ZM7 13a.5.5 0 0 0 .5-.5V6a.5.5 0 1 0-1 0v6.5c0 .275.225.5.5.5Zm-2.5 0c.275 0 .5-.225.5-.5V6a.5.5 0 1 0-1 0v6.5c0 .275.225.5.5.5Zm5 0a.5.5 0 0 0 .5-.5V6a.5.5 0 1 0-1 0v6.5c0 .275.225.5.5.5Z"
            />
        </svg>
    );
};

export default React.memo(Delete);
